var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRise(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ArrowRise"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.45488 5.94108L14 4.33331L12.6198 9.93942L10.898 8.28652L8.12069 11.1796C8.02641 11.2778 7.89615 11.3333 7.76 11.3333C7.62385 11.3333 7.49359 11.2778 7.39931 11.1796L5.36 9.0553L2.36069 12.1796C2.16946 12.3788 1.85294 12.3852 1.65373 12.194C1.45453 12.0028 1.44807 11.6863 1.63931 11.487L4.99931 7.98705C5.09359 7.88883 5.22385 7.83331 5.36 7.83331C5.49615 7.83331 5.62641 7.88883 5.72069 7.98705L7.76 10.1113L10.1766 7.59398L8.45488 5.94108Z",
    fill: "#1C1C1C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRise);
export default __webpack_public_path__ + "static/media/ArrowRise.72ed18ccead92d8fb40515797bfaaafe.svg";
export { ForwardRef as ReactComponent };